import { grey, red } from "@mui/material/colors";

const styles = {
  mainContainer: {
    padding: "0px",
  },
  logoContainer: {
    padding: "20px 0px",
    maxWidth: "300px",
    width: "100%",
    display: "flex",
    flexDirection: "row",
    marginLeft: "20px",
    justifyContent: "start",
    alignItems: "center",
  },
  logoImage: {
    width: "36px",
  },
  logoName: {
    marginLeft: "12px",
    color: grey[800],
    fontSize: "28px",
    fontWeight: "bold",
  },
  divider: {
    listStyle: "none",
  },
  userContainer: {
    padding: "0px 0px",
    maxWidth: "300px",
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  avatar: {
    bgcolor: grey[200],
    fontWeight: 'bold',
    color: grey[600]
  },
  logoutButton: {
    color: red[500]
  },
  selectedItem: {
    width: 260,
    marginLeft: '10px',
    borderRadius: 12,
    color: red[500],
    backgroundColor: red[50],
    '&:hover': {
      backgroundColor: red[200],
    },
  },
  unselectedItem: {
    width: 260,
    marginLeft: '10px',
    borderRadius: 12,
    color: grey[800],
    '&:hover': {
      backgroundColor: grey[200],
    },
  },
  selectedItemIcon: {
    color: red[500],
  },
  unselectedItemIcon: {
    color: grey[800],
  },
  itemIcon: {
    minWidth: 40
  },
  regionContainer: {
    padding: "8px 16px",
    margin: "8px 0px",
    width: "100%",
    backgroundColor: red[50],
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  regionText: {
    color: red[500],
    fontWeight: "semibold",
    fontSize: "1rem",
  }
};

export default styles;
